<template>
    <el-row>
      检查检验结果
      {{entity}}
    </el-row>
  </template>
  <script>
  import api from "../api"
  export default {
    props: {
      entity: Object
    }
  }
  </script>